import { Controller } from "@hotwired/stimulus"

// Builds a mailto link client-side from a reversed address, so the real "user@domain" string
// and the mailto: link never appear in the server-rendered HTML where a scraper's regex could
// find them (see ApplicationHelper#obfuscated_email_link, used on the legal pages' support
// address). Real visitors with JavaScript get a normal link in place of this element; the
// <noscript> fallback rendered right after it covers everyone else.
export default class extends Controller {
  static values = { address: String, text: String }

  connect() {
    const decode = (reversed) => reversed.split("").reverse().join("")
    const link = document.createElement("a")
    link.href = `mailto:${decode(this.addressValue)}`
    link.textContent = decode(this.textValue)
    this.element.replaceWith(link)
  }
}
